// OWNER: Agent C. Consistent page title + optional trailing action across views.
import type { ReactNode } from "react";
import { Text } from "@cloudflare/kumo/components/text";

export function PageHeader({ title, action, description }: { title: string; action?: ReactNode; description?: string }) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-3">
      <div>
        <Text variant="heading" size="lg" as="h1">
          {title}
        </Text>
        {description && (
          <div className="mt-1">
            <Text variant="secondary" size="sm">
              {description}
            </Text>
          </div>
        )}
      </div>
      {action}
    </div>
  );
}
